import React from "react";
import { style } from "glamor";

export default function Spacer() {
    return <div {...style({ height: "12px" })} />;
}
